import React from 'react';
import useKidListFunctionality from '../../../customHooks/kidListHook';
import DefaultUser from "../../../../assets/images/default-user.svg";
import { useSelector } from 'react-redux';

const ParentListRow = ({
    item: data,
    openEditModal,
    openModal,
    checkSubsciption
}) => {
    const { getImage } = useKidListFunctionality();
    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);
    return (
        <>
            <tr key={data?.ID} id={data?.ID} >
                <td>
                    <div className="d-inline-flex  align-items-center">
                        <span className={`icon-wrap icon-sm p-0 border-0 flex-shrink-0 ${lang?.isRTL === 1 ? 'ms-6' : 'me-6'}`}>
                            <img
                                src={getImage(data?.AdditionalParentImage)}
                                alt=""
                                onError={(event) => {
                                    event.target.onerror = null;
                                    event.target.src = DefaultUser;
                                }}
                            />
                        </span>
                        {data?.FullName}
                    </div>
                </td>
                <td>{data?.Email}</td>
                <td>
                    <div className="d-inline-flex align-items-center gap-6">
                        <i
                            className="icon-edit text-blue-800 fs-6 pt-cursor"
                            onClick={() => {
                                if(!checkSubsciption()) {
                                    return;
                                }
                                openEditModal(data)
                            }}
                        />
                        <i
                            className="icon-trash text-danger fs-5 pt-cursor"
                            onClick={() => {
                                if(!checkSubsciption()) {
                                    return;
                                }
                                openModal(data)
                            }}
                        />
                    </div>
                </td>
            </tr>
        </>
    )
}

export default ParentListRow